module.exports = __webpack_public_path__ + "img/fondo-banner-principal.8c4dd231.svg";